<template>
	<div class="white-file-list-view">
		<div class="file" v-for="(file, i) in value" v-bind:key="i" @click="open(file.id)">
			<div class="lbl">{{ file.name }}</div>
			<div class="tb">
				<div @click.stop="del(i)">Slet</div>
			</div>
		</div>
		<div class="btn" @click="select">Tilføj fil</div>
		<input type="file" ref="file" @change="change" multiple />
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			del(i) {
				this.value.splice(i, 1);
			},
			rename(file) {
				var name = prompt('Navn', file.name);

				if (name == '') return;

				file.name = name;
			},
			select() {
				this.$refs.file.click();
			},
			change(e) {
				console.log(e.target);

				this.upload(e);
			},
			upload(e) {
				console.log('upload', e.target, e.target.files);

				var self = this;

				//var formData = new FormData();
				//formData.append('file', e.target.files[0]);

				this.$emit('input', this.value.concat([...e.target.files]));

				console.log('files', this.value);

				/*this.axios
					.post('/storage/', formData)
					.then(function (r) {
						console.log(r.data);

						self.value.push({
							id: r.data,
							label: 'Ny fil - ' + (new Date()).format('Y-m-d')
						});
					});*/
			},
			open(file) {
				/*this.axios
					.get('/storage/urls/' + file + '/')
					.then(function (r) {
						console.log(r.data);

						window.open(r.data, '_blank');
					});*/
			}
		}
	}
</script>

<style lang="scss" scoped>
	.white-file-list-view {
		overflow: hidden;

		& > input {
			position: absolute;
			left: -500px;
		}

		& > .file {
			position: relative;
			padding-left: 0;
			margin-bottom: 10px;
			padding-right: 50px;

			& > .lbl {
				line-height: 30px;
				text-align: left;
				white-space: nowrap;
				text-overflow: ellipsis;
				width: 100%;
				overflow: hidden;
			}

			& > .tb {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 0;
					font-size: 12px;
					line-height: 30px;
					cursor: pointer;
				}
			}
		}

		& > .btn {
			border-radius: 3px;
			border: 1px solid #d1d1d1;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
		}
	}
</style>